import { persistAuthTokenFromResponse } from '@/lib/auth/persist-auth-token';
import { axiosInstance } from '@/lib/utils';
import type { BusinessCreationPayload, BusinessUpdatePayload } from './payload';
import type { BusinessCreationResponse } from './response';
import type { BusinessVerifyPayload } from './verify-payload';
import { endpoints } from '@/api';
import type { RequestResponse } from '@/types';
import type { Business } from '@/types/business';

export const createBusiness = async (payload: BusinessCreationPayload) => {
  const response = await axiosInstance.post<BusinessCreationResponse>(
    endpoints.business,
    payload
  );
  persistAuthTokenFromResponse(response.data);
  return response.data;
};

export const updateBusiness = async (payload: BusinessUpdatePayload) => {
  const response = await axiosInstance.patch<RequestResponse<Business>>(
    endpoints.businessMe,
    payload
  );
  return response.data;
};

export const verifyBusiness = async (payload: BusinessVerifyPayload) => {
  const response = await axiosInstance.post<RequestResponse<unknown>>(
    endpoints.businessVerify,
    payload
  );
  return response.data;
};
